import axios from 'axios';
import router from '../router'
import globalConfig from "../config";
import uiUtils from "./uiUtils"
import store from "../store"

var accessToken = "";
// var httpAdapter = require('axios/lib/adapters/http');
// var https = require('https')

export const getAccessToken = () => {
    return accessToken;
}

export const setAccessToken = (token) => {
    accessToken = token;
}


const myAxios = axios.create({
    // httpsAgent:new https.Agent({ rejectUnauthorized:false}),

// 　　adapter: httpAdapter,

　　baseURL: globalConfig.getServerUrl(),

　　timeout: 60000,

// 　　headers: {accessToken: 'accessToken'}
    
})

// 超时设定
myAxios.defaults.timeout = 60000;

myAxios.interceptors.request.use(config => {
    
    // config.adapter = httpAdapter,
    // console.log("interceptors adapter = " + config.adapter);

    config.headers.accessToken = accessToken;

    config.baseURL = globalConfig.getServerUrl();

    return config;

}, err => {
    uiUtils.showErrorMsg("请求超时");
    
    return Promise.resolve(err);
});

// http response 拦截器
myAxios.interceptors.response.use(response => {
    const data = response.data;
    
    if (data.status == undefined) {
        return data;
    }
    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.status) {
        case 0:
            break;

        case 10004:
            uiUtils.showErrorMsg("登陆过期，需要重新登陆");
            store.commit("user/clearUser");
            // router.replace({ path: '/' })
            router.replace({name: "Login"});
            return Promise.reject(data);
      
        default:
            // 错误
            console.error(data);
            uiUtils.showErrorMsg(data.message);
            return Promise.reject(data);
    }
  
    return data.content;
}, (err) => {
    // 返回状态码不为0时候的错误处理
    console.error(err.toString());
    uiUtils.showErrorMsg(err.toString());
    return Promise.reject(err);
});

export const getRequest = (url, params, type='application/json') => {
    
    return myAxios({
      method: 'get',
      url: `${url}`,
      params: params,
      headers: {
        'Content-Type':'application/json;charset=UTF-8',
        Accept: type
      }
    });
  };
  
  export const patchRequest = (url, params) => {
    
    return myAxios({
      method: 'patch',
      url: `${url}`,
      params: params,
    //   headers: {
    //     'accessToken': accessToken
    //   }
    });
  };
  
  export const postRequest = (url, params, contentType='application/json') => {
    
    let transformRequest = [function (params) {
      let ret = '';
      for (let it in params) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&';
      }
      return ret;
    }];
    let header = {
      'Content-Type': contentType === undefined ? 'application/x-www-form-urlencoded' : contentType,
      'accessToken': accessToken
    };
    let axiosObj = {
      method: 'post',
      url: `${url}`,
      data: params
    };
    if (contentType === undefined || contentType.search("application/json") === -1) {
      axiosObj.header = header;
      axiosObj.transformRequest = transformRequest;
    }
    return myAxios(axiosObj);
  };

  export const postRequestBlob = (url, params, contentType='application/json') => {
    
    let transformRequest = [function (params) {
      let ret = '';
      for (let it in params) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&';
      }
      return ret;
    }];
    let header = {
      'Content-Type': contentType === undefined ? 'application/x-www-form-urlencoded' : contentType,
      'accessToken': accessToken
    };
    let axiosObj = {
      method: 'post',
      responseType: 'blob',
      url: `${url}`,
      data: params
    };
    if (contentType === undefined || contentType.search("application/json") === -1) {
      axiosObj.header = header;
      axiosObj.transformRequest = transformRequest;
    }
    return myAxios(axiosObj);
  };
  
  export const putRequest = (url, params, contentType='application/json') => {
    
    let header = {
      'Content-Type': contentType === undefined ? 'application/x-www-form-urlencoded' : contentType,
    //   'accessToken': accessToken
    };
    let transformRequest = [function (params) {
      let ret = '';
      for (let it in params) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&';
      }
      return ret;
    }];
    let axiosObj = {
      method: 'put',
      url: `${url}`,
      data: params
    };
    if (contentType === undefined || contentType.search("application/json") === -1) {
      axiosObj.header = header;
      axiosObj.transformRequest = transformRequest;
    }
    return myAxios(axiosObj);
  };
  
  export const deleteRequest = (url, params, contentType='application/json') => {
    
    return myAxios({
      method: 'delete',
      url: `${url}`,
      params: params,
      headers: {
        'Content-Type': contentType === undefined ? 'application/x-www-form-urlencoded' : contentType,
        // 'accessToken': accessToken
      }
    });
  };

  export const deleteRequest1 = (url, params, contentType='application/json') => {
    
    return myAxios({
      method: 'delete',
      url: `${url}`,
      data: `${params}`,
      headers: {
        'Content-Type': contentType === undefined ? 'application/x-www-form-urlencoded' : contentType,
        // 'accessToken': accessToken
      }
    });
  };
  
  export const uploadFileRequest = (url, params) => {

    return myAxios({
      method: 'post',
      url: `${url}`,
      params: params,
    //   headers: {
    //     'accessToken': accessToken
    //   }
    });
  };


// WEBPACK FOOTER //
// ./src/utils/api.js